import {
  Button,
  CircularProgress,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import Accordion from "@mui/material/Accordion";
import moment from "moment";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";
import { path } from "../../../order_managment/constants/apiPath";
import routeConstant from "../../../route/compoent/routeConstant";
import { getUserData } from "../../common/utility/Utils";
import "./rms.css";
import { NotificationManager } from "react-notifications";
import { useContext } from "react";
import { StoreContext } from "../../../store/Provider";
import DailogueDetails from "./DailogueDetails";
import { Autocomplete, Box, Stack, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import QuoteTable from "./QuoteTable";

// const filterOptions = [
//   `All ${}`,
//   "Booked",
//   "Confirmed",
//   "Hazardous",
//   // "Unbooked Quote",
//   "Unbooked",
// ];
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const QuoteList = () => {
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [quotelist, setQuotelist] = useState([]);
  const [dailogueOpen, setDailogueOpen] = useState(false);
  const [detailsResult, setDetailsResult] = useState({});
  const [tempList, setTempList] = useState([]);
  const [updateList, setUpdateList] = useState(false);
  const [value, setValue] = React.useState(0);
  const [rightPanelShow, setRightPanelShow] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [expanded, setExpanded] = useState(false);
  const [expandedInTable, setExpandedInTable] = useState(false);
  const [expandedInTable2, setExpandedInTable2] = useState(false);

  const [totalQuotes, setTotalQuote] = useState(0);
  const filterOptions = [
    `All (${totalQuotes})  `,
    "Booked",
    "Confirmed",
    "Hazardous",
    // "Unbooked Quote",
    "Unbooked",
  ];

  const calculateAmmount = (ammount) => {
    const amt = Number(parseFloat(ammount).toFixed(2)).toLocaleString("en-US", {
      minimumFractionDigits: 2,
    });

    return amt;
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  console.log("DATAFTAF", detailsResult);

  const getQuoteList = async () => {
    setLoading(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.GET_QUOTE_LIST}${
      data.user_name.split("@")[0]
    }`;
    axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        setLoading(false);
        const temp = res.data.userSpecificQuotes.reverse();
        const count = res.data.recCount;
        setTotalQuote(count);
        setQuotelist(temp ?? []);
        setTempList(temp ?? []);
      })
      .catch((err) => {
        setLoading(false);
        setQuotelist([]);
        console.log(err);
      });
  };

  const getRateFreight = async () => {
    setLoading(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.GET_FREIGHT_RATE}`;
    const body = {
      fromCode: location.state?.origin?.originCode ?? "",
      toCode: location.state?.destination.destinationCode ?? "",
      quantity: location.state?.cbm ?? "",
    };
    axios
      .post(url, body, {
        headers: header,
      })
      .then((res) => {
        bookQuote(res.data[0]);
      })
      .catch((err) => {
        getQuoteList();
        console.log(err);
      });
  };

  console.log("User Role: ", context.omsUserData);

  const confirmBooking = async () => {
    setLoading2(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url = "";
    if (context.omsUserData?.UserRoles.includes("Admin")) {
      url = `${baseUrlRate}${path.CONFIRM_BOOKING_ADMIN}`;
    } else {
      url = url = `${baseUrlRate}${path.BOOK_QUOTE}`;
    }

    const body = {
      quote_BookingId: detailsResult.quote_BookingId ?? "",
      // bookingMadeByUserId: quoteResult?.quote_BookingId.split("_")[1] ?? "",
      bookingMadeByUserId: detailsResult.emailIdOfUser.split("@")[0] ?? "",
    };

    axios
      .put(url, body, {
        headers: header,
      })
      .then((res) => {
        setLoading2(false);
        NotificationManager.success("Your quote has been confirmed.", "", 3000);
        // setUpdateList(true);
        setRightPanelShow(!rightPanelShow);
        getQuoteList();
        // window.location.reload();
        // setDailogueOpen(false);
        // navigate(routeConstant.QUOTE);
      })
      .catch((err) => {
        NotificationManager.error("Something went wrong!", "", 3000);
        console.log(err);
        // setLoading2(false);
      });
  };

  const onClickBookQuote = async () => {
    setLoading1(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.BOOK_QUOTE}`;
    const body = {
      quote_BookingId: detailsResult.quote_BookingId ?? "",
      bookingMadeByUserId: detailsResult.emailIdOfUser.split("@")[0] ?? "",
    };

    axios
      .put(url, body, {
        headers: header,
      })
      .then((res) => {
        setLoading1(false);
        NotificationManager.success(
          "Your quote has been booked successFully",
          "",
          3000
        );
        getQuoteList();
        // setDailogueOpen(false);
        // navigate(routeConstant.QUOTE);
      })
      .catch((err) => {
        NotificationManager.error("Something went wrong!", "", 3000);
        console.log(err);
        setLoading(false);
      });
  };

  const bookQuote = async (item) => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.CREATE_QUOTE}`;

    const body = {
      bookingMadeByUserId: data.user_name.split("@")[0],
      emailIdOfUser: data.user_name,
      bookingMadeForCompanyCode:
        location.state?.userType === "SALES"
          ? location.state?.saleCompanyCode?.organizationCode
          : location.state?.companyCode,
      freightQuoteAgainstPriceId: item?.lclPrice?.id ?? 1,
      freightQty: location.state?.cbm ?? 0,
      ipiQuoteAgainstPriceId: item?.ipiPrice?.id ?? 1,
      ipiQty: location.state?.cbm ?? 0,
      isLMDOpted:
        parseInt(location.state.weight) * 2204.62262185 > 50000 &&
        context.lmdResponse?.success
          ? false
          : JSON.parse(location.state.isLastMileSelected),
      originZipCode: context.lmdResponse?.success
        ? location.state.destination.destinationZipCode ?? ""
        : "",
      destinationZipCode: context.lmdResponse?.success
        ? location.state.finalDestination ?? ""
        : "",
      lmdQuoteAmount: context.lmdResponse?.success
        ? context.lmdResponse?.rateEstimate?.netFreightCharge ?? 0
        : 0,
      lmdDestinationAddress: context.lmdResponse?.success
        ? location?.state?.lmdDestinationAddress ?? ""
        : "",
      lmdQuoteId: context.lmdResponse?.success
        ? context.lmdResponse?.referenceNumber ?? ""
        : "",
      lmdQuoteValidTill: "2099-03-29T10:55:42.674Z",
      totalQuotedAmount: item?.total_rate ?? 0,
      isInsuraceOpted: JSON.parse(location.state.isInsuraceOpted),
      isCustomClearaceOpted: JSON.parse(location.state.isCustomClearaceOpted),
      isHazardous: JSON.parse(location.state.isHazardous),
      pieceCount: location.state.pieceCount,
      weight: parseInt(location.state.weight),
      dimensionHeight: location.state.dimensionHeight,
      dimensionLength: location.state.dimensionLength,
      dimensionWidth: location.state.dimensionWidth,
      commodity: location.state.commodity,
    };
    axios
      .post(url, body, {
        headers: header,
      })
      .then((res) => {
        getQuoteList();
      })
      .catch((err) => {
        getQuoteList();
        console.log(err);
      });
  };

  useEffect(() => {
    if (location?.state?.isHazardous) {
      getRateFreight();
    } else {
      getQuoteList();
    }
  }, [updateList]);

  const filterData = (item) => {
    const temp = [];

    for (let i = 0; i < tempList.length; i++) {
      if (item === "Booked") {
        if (tempList[i].isBooked && !tempList[i].isBookingConfirmed) {
          temp.push(tempList[i]);
        }
      } else if (item === "Hazardous") {
        if (
          tempList[i].isHazardous &&
          !tempList[i].isBooked &&
          !tempList[i].isBookingConfirmed
        ) {
          temp.push(tempList[i]);
        }
      } else if (item === "Confirmed") {
        if (
          !tempList[i].isHazardous &&
          tempList[i].isBooked &&
          tempList[i].isBookingConfirmed
        ) {
          temp.push(tempList[i]);
        }
      } else if (item === "Unbooked") {
        if (
          !tempList[i].isBooked &&
          !tempList[i].isBookingConfirmed &&
          !tempList[i].isHazardous
        ) {
          temp.push(tempList[i]);
        }
      } else {
        temp.push(tempList[i]);
      }
    }

    setQuotelist(temp);
  };
  const handleChange = (event, newValue) => {
    filterData(filterOptions[newValue]);
    setValue(newValue);
    setRightPanelShow(false);
  };
  return (
    <div>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center w-100 h-100">
          <CircularProgress size="2rem" />
        </div>
      ) : (
        <>
          <Grid container spacing={0}>
            {context.omsUserData.UserRoles.includes("Admin") ? (
              <Grid item xs={12} md={12} lg={12}>
                <Typography variant="outlined">
                  All quote(s) and booking(s)
                </Typography>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography
                  variant="subtitle2"
                  onClick={() => {
                    navigate(routeConstant.CREATEQUOTE);
                  }}
                >
                  My quote(s) and booking(s)
                </Typography>
                <button
                  onClick={() => {
                    navigate(routeConstant.CREATEQUOTE);
                  }}
                  style={{
                    borderRadius: "5px",
                    background:
                      "linear-gradient(90deg, #002e76 0%, #007cd6 100%)",
                    color: "white",
                  }}
                >
                  Create Quote
                </button>
              </Grid>
            )}

            <Grid item xs={6} md={6} lg={6}>
              <Box sx={{ width: "100%", paddingRight: "10px" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="Tab bar"
                    indicatorColor="primary"
                    textColor="inherit"
                    variant="fullWidth"
                  >
                    {filterOptions.map((item, index) => {
                      return (
                        <Tab
                          label={
                            <Typography variant="caption" color="primary">
                              {item}
                            </Typography>
                          }
                          {...a11yProps(index)}
                        />
                      );
                    })}
                  </Tabs>
                </Box>
                {filterOptions.map((item, index) => {
                  return (
                    <TabPanel
                      value={value}
                      index={index}
                      style={{ height: "78vh", overflow: "auto" }}
                    >
                      {quotelist.length ? (
                        <Grid
                          container
                          spacing={2}
                          style={{
                            // height: "65vh",
                            overflow: "auto",
                            padding: "0px",
                          }}
                        >
                          {quotelist.map((i, index) => {
                            return (
                              <Grid
                                item
                                xs={12}
                                key={index}
                                style={{
                                  padding: "0px 10px",
                                  // marginTop: "-9px",
                                  // alignItems: "self-start",
                                }}
                              >
                                <Paper
                                  className="quote-card"
                                  onClick={() => {
                                    console.log("Card clicked");
                                    setRightPanelShow(true);
                                    setExpanded(false);
                                    setExpandedInTable(false);
                                    // setExpandedInTable2(false);
                                    setDetailsResult(i);
                                    setDailogueOpen(true);
                                  }}
                                  elevation={3}
                                  style={
                                    rightPanelShow &&
                                    index ===
                                      quotelist.length - detailsResult?.id
                                      ? {
                                          backgroundColor: "#f4f4f4",
                                          marginBottom: "1rem",
                                          padding: "0.5rem",
                                        }
                                      : {
                                          marginBottom: "1rem",
                                          padding: "0.5rem",
                                        }
                                  }
                                >
                                  <Grid container>
                                    <Grid
                                      item
                                      md={12}
                                      lg={12}
                                      xs={12}
                                      style={{
                                        height: "40px",
                                        position: "relative",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {/* {console.log(
                                        "Index: ",
                                        index,
                                        "Details ID: ",
                                        detailsResult?.id - 1
                                      )} */}
                                      {i?.isBooked && !i?.isBookingConfirmed ? (
                                        <>
                                          <div
                                            // className="blink_me"
                                            style={{
                                              backgroundColor: "#4290f5",
                                              color: "white",
                                              fontWeight: "700",
                                              // width: "100px",
                                              position: "absolute",
                                              top: "0px",
                                              left: "-25px",
                                              // height: "",
                                              padding: "0px 5px 0px 10px",
                                            }}
                                          >
                                            <span>Booked</span>
                                          </div>
                                        </>
                                      ) : i?.isHazardous &&
                                        !i?.isBooked &&
                                        !i?.isBookingConfirmed ? (
                                        <p
                                          // className="blink_me"
                                          style={{
                                            backgroundColor: "red",
                                            color: "white",
                                            fontWeight: "700",
                                            // width: "100px",
                                            position: "absolute",
                                            top: "0px",
                                            left: "-25px",
                                            // height: "",
                                            padding: "0px 5px 0px 10px",
                                          }}
                                        >
                                          Hazardous
                                        </p>
                                      ) : i?.isBooked &&
                                        i?.isBookingConfirmed &&
                                        !i?.isHazardous ? (
                                        <div
                                          // className="blink_me"
                                          style={{
                                            backgroundColor: "#13eb0c",
                                            color: "white",
                                            fontWeight: "700",
                                            // width: "100px",
                                            position: "absolute",
                                            top: "0px",
                                            left: "-25px",
                                            // height: "",
                                            padding: "0px 5px 0px 10px",
                                          }}
                                        >
                                          <span>Confirmed</span>
                                        </div>
                                      ) : !i?.isBooked &&
                                        !i?.isBookingConfirmed &&
                                        !i?.isHazardous ? (
                                        <>
                                          <div
                                            // className="blink_me"
                                            style={{
                                              backgroundColor: "#f59c02",
                                              color: "white",
                                              fontWeight: "700",
                                              // width: "100px",
                                              position: "absolute",
                                              top: "0px",
                                              left: "-25px",
                                              // height: "",
                                              padding: "0px 5px 0px 10px",
                                            }}
                                          >
                                            <span>Unbooked Quote</span>{" "}
                                          </div>
                                          {/* {context.omsUserData.UserRoles.includes(
                                            "Admin"
                                          ) ? (
                                            ""
                                          ) : (
                                            <button
                                              style={{
                                                backgroundColor: "#4290f5",
                                                color: "white",
                                                fontWeight: "700",
                                                // width: "100px",
                                                position: "absolute",
                                                top: "0px",
                                                right: "0px",
                                                borderRadius: "5px",
                                              }}
                                            >
                                              Book Quote
                                            </button>
                                          )} */}
                                        </>
                                      ) : null}
                                    </Grid>
                                    <Grid item xs={12} md={8} lg={8}>
                                      <Stack
                                        direction="column"
                                        spacing={3}
                                        style={{
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        {i?.isBooked ? (
                                          <Typography
                                            variant="button"
                                            style={{ color: "#827e7e" }}
                                          >
                                            Booking Id:
                                          </Typography>
                                        ) : (
                                          <Typography
                                            variant="button"
                                            style={{ color: "#827e7e" }}
                                          >
                                            {i?.isHazardous ? null : (
                                              <span>Quote</span>
                                            )}{" "}
                                            Id
                                          </Typography>
                                        )}
                                        <Typography
                                          variant="overline"
                                          style={{
                                            wordBreak: "break-word",
                                            fontSize: "16px",
                                            margin: "0",
                                          }}
                                        >
                                          {i?.quote_BookingId ?? "N/A"}
                                        </Typography>
                                      </Stack>
                                    </Grid>

                                    <Grid item xs={12} sm={5} md={4} lg={4}>
                                      {i?.isHazardous ? null : (
                                        <>
                                          <Typography
                                            variant="button"
                                            style={{ color: "#827e7e" }}
                                          >
                                            Total Amount:
                                          </Typography>
                                          <Typography
                                            style={{ wordBreak: "break-word" }}
                                          >
                                            {i?.totalQuotedAmount
                                              ? `${calculateAmmount(
                                                  i?.totalQuotedAmount
                                                )} USD`
                                              : "N/A"}
                                          </Typography>
                                        </>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                            );
                          })}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={12}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <Typography>No data found!</Typography>
                        </Grid>
                      )}
                    </TabPanel>
                  );
                })}

                {/* <TabPanel value={value} index={1}>
                  Item Two
                </TabPanel>
                <TabPanel value={value} index={2}>
                  Item Three
                </TabPanel>
                <TabPanel value={value} index={3}>
                  Item Four
                </TabPanel>
                <TabPanel value={value} index={4}>
                  Item Five
                </TabPanel> */}
              </Box>
            </Grid>
            <Grid item xs={6} md={6} lg={6} style={{ marginTop: "3rem" }}>
              <Grid
                container
                spacing={2}
                style={{
                  height: "75vh",
                  overflow: "auto",
                  padding: "0px",
                }}
              >
                {rightPanelShow && (
                  <>
                    <Grid
                      item
                      xs={12}
                      style={{
                        // padding: "10px 10px",
                        marginTop: "-9px",
                      }}
                    >
                      <Paper
                        elevation={3}
                        style={{
                          margin: "10px 0 1rem 0",
                          padding: "0.5rem 1rem",
                        }}
                      >
                        <Grid
                          container
                          style={
                            !detailsResult?.isHazardous
                              ? {
                                  // flexDirection: "column",
                                  aligItems: "center",
                                  justifyContent: "space-around",

                                  width: "100%",
                                }
                              : {
                                  // flexDirection: "column",
                                  aligItems: "center",
                                  justifyContent: "center",

                                  width: "100%",
                                }
                          }
                        >
                          <Grid
                            item
                            xs={12}
                            sm={5}
                            md={5}
                            lg={5}
                            style={{
                              display: "flex",
                              // width: "10%",
                              // flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              {" "}
                              <Typography
                                variant="button"
                                // style={{ color: "#827e7e" }}
                              >
                                Origin{" "}
                              </Typography>
                              <Typography
                                style={{
                                  wordBreak: "break-word",
                                  // paddingLeft: "10px",
                                  fontSize: "16px",
                                }}
                              >
                                {detailsResult.freightOrigin ?? "N/A"}
                              </Typography>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  backgroundColor: "#4290f5",
                                  borderRadius: "50%",
                                  marginLeft: "5px",
                                }}
                              ></div>
                              <div
                                style={{
                                  width: "91%",
                                  borderBottom: "2px dotted #4290f5",
                                }}
                              ></div>
                            </div>
                          </Grid>
                          {!detailsResult?.isHazardous && (
                            <Grid
                              item
                              xs={12}
                              sm={2}
                              md={2}
                              lg={2}
                              style={{
                                display: "flex",
                                // width: "100%",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "10px",
                              }}
                            >
                              {detailsResult.isHazardous ? null : (
                                <>
                                  {/* <Typography variant="button">Route</Typography> */}
                                  <Typography
                                    style={{
                                      wordBreak: "break-word",
                                      // paddingTop: "10px",
                                      // paddingLeft: "20px",
                                      fontSize: "12px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <span style={{ fontWeight: 700 }}>
                                      Via{" "}
                                    </span>
                                    {detailsResult.freightDestination ?? "N/A"}(
                                    {detailsResult.freightDestinationCode ??
                                      "N/A"}
                                    )
                                  </Typography>
                                </>
                              )}
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={12}
                            sm={5}
                            md={5}
                            lg={5}
                            style={{
                              display: "flex",
                              // width: "100%",
                              // flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  width: "90%",
                                  borderBottom: "2px dotted #4290f5",
                                }}
                              ></div>

                              <div
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  backgroundColor: "#4290f5",
                                  borderRadius: "50%",
                                  marginRight: "5px",
                                }}
                              ></div>
                            </div>
                            <div>
                              <Typography
                                variant="button"
                                // style={{ color: "#827e7e" }}
                              >
                                Destination
                              </Typography>
                              <Typography
                                style={{
                                  wordBreak: "break-word",
                                  // paddingLeft: "10px",
                                  fontSize: "16px",
                                }}
                              >
                                {detailsResult.ipiDestination ?? "N/A"} (
                                {detailsResult.ipiDestinationCode ?? "N/A"})
                              </Typography>
                            </div>
                          </Grid>
                          <Grid item xs={12} className="showmore-quote">
                            <Accordion
                              expanded={expanded === "panel1"}
                              onChange={handleAccordionChange("panel1")}
                              style={{ boxShadow: "none" }}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                              >
                                <Typography
                                  style={{
                                    // width: "33%",
                                    flexShrink: 0,
                                    fontSize: "14px",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <button
                                    style={{
                                      border: "1px solid rgb(66, 144, 245)",
                                      borderRadius: "50px",
                                      backgroundColor: "rgb(66, 144, 245)",
                                      color: "white",
                                      // height: "30px",
                                    }}
                                  >
                                    {expanded ? "Show less" : "Show more"}
                                  </button>
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container style={{ fontSize: "18px" }}>
                                  <Grid item xs={12}>
                                    <QuoteTable
                                      detailsResult={detailsResult}
                                      expandedInTable={expandedInTable}
                                      setExpandedInTable={setExpandedInTable}
                                      expandedInTable2={expandedInTable2}
                                      setExpandedInTable2={setExpandedInTable2}
                                    />
                                  </Grid>

                                  <Grid item xs={12}>
                                    <Typography
                                      style={{
                                        display: "flex",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        color: "red",
                                        padding: "0.3rem 0",
                                        // textAlign: "center",
                                        fontSize: "18px",
                                      }}
                                    >
                                      {/* This Quotation is subject to in and out warehouse charges */}
                                      Rates are valid 2 weeks from the date of
                                      quote creation.
                                      <br />
                                      Rates are included the warehouse in and
                                      out charges.
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    style={{ justifyContent: "flex-end" }}
                                  >
                                    <div className="d-flex justify-content-end">
                                      {detailsResult?.isBooked &&
                                      !detailsResult?.isBookingConfirmed &&
                                      context.omsUserData.UserRoles.includes(
                                        "Admin"
                                      ) ? (
                                        <button
                                          onClick={confirmBooking}
                                          style={{
                                            backgroundColor: "#00e216",
                                            color: "white",
                                            fontWeight: "700",
                                            width: "120px",
                                            // position: "absolute",
                                            // top: "0px",
                                            // right: "0px",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          {loading2 ? (
                                            <CircularProgress size="1rem" />
                                          ) : (
                                            "Confirm"
                                          )}
                                        </button>
                                      ) : !detailsResult?.isBooked &&
                                        !detailsResult?.isBookingConfirmed &&
                                        !detailsResult?.isHazardous ? (
                                        context.omsUserData.UserRoles.includes(
                                          "Admin"
                                        ) ? (
                                          ""
                                        ) : (
                                          <button
                                            onClick={onClickBookQuote}
                                            style={{
                                              backgroundColor: "#4290f5",
                                              color: "white",
                                              fontWeight: "700",
                                              width: "160px",
                                              // position: "absolute",
                                              // top: "0px",
                                              // right: "0px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {loading1 ? (
                                              <CircularProgress size="1rem" />
                                            ) : (
                                              "Book Quote"
                                            )}
                                          </button>
                                        )
                                      ) : null}
                                    </div>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          {/*Old code goes here */}
        </>
      )}
    </div>
  );
};

export default QuoteList;

/*Old Code */

{
  /* <Grid
            container
            style={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: "#f8f9ff",
            }}
          >
            <Grid
              container
              style={{
                maxHeight: "3.5rem",
                display: "flex",
                justifyContent: "flex-end",
                paddingBottom: "1rem",
                paddingRight: "0.5rem",
              }}
            >
              {setDailogueOpen ? (
                <DailogueDetails
                  setUpdateList={setUpdateList}
                  dailogueOpen={dailogueOpen}
                  setDailogueOpen={setDailogueOpen}
                  quoteResult={detailsResult}
                  setQuotelist={setQuotelist}
                  quotelist={quotelist}
                />
              ) : null}
              {context.omsUserData.UserRoles.includes("Admin") ? (
                <Grid item xs={6}>
                  <Typography
                    variant="outlined"
                    onClick={() => {
                      navigate(routeConstant.CREATEQUOTE);
                    }}
                  >
                    All quote(s) and booking(s)
                  </Typography>
                </Grid>
              ) : (
                <Grid item xs={6}>
                  <Typography
                    variant="outlined"
                    onClick={() => {
                      navigate(routeConstant.CREATEQUOTE);
                    }}
                  >
                    My quote(s) and booking(s)
                  </Typography>
                </Grid>
              )}
              <Grid item xs={3}>
                <Autocomplete
                  disablePortal
                  fullWidth
                  variant="outlined"
                  id="combo-box-demo"
                  options={filterOptions.map((option) => option)}
                  renderInput={(params) => (
                    <TextField {...params} label="Select" />
                  )}
                  onChange={(event, newValue) => {
                    filterData(newValue);
                  }}
                  getOptionLabel={(option) => option}
                />
              </Grid>

              {context.omsUserData.UserRoles.includes("Admin") ? null : (
                <Grid
                  item
                  xs={3}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      navigate(routeConstant.CREATEQUOTE);
                    }}
                  >
                    Create Quote
                  </Button>
                </Grid>
              )}
            </Grid>
            {quotelist.length ? 
              (
              <>
                {quotelist.map((i, index) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <Paper
                        onClick={() => {
                          setDetailsResult(i);
                          setDailogueOpen(true);
                        }}
                        elevation={3}
                        style={{ marginBottom: "1rem", padding: "0.5rem" }}
                      >
                        <Grid container>
                          <Grid item xs={6}>
                            <Stack
                              direction="row"
                              spacing={3}
                              style={{
                                alignItems: "center",
                              }}
                            >
                              {i?.isBooked ? (
                                <Typography
                                  variant="button"
                                  // style={{ color: "#827e7e" }}
                                >
                                  Booking Id :
                                </Typography>
                              ) : (
                                <Typography
                                  variant="button"
                                  // style={{ color: "#827e7e" }}
                                >
                                  {i?.isHazardous ? null : <span>Quote</span>}{" "}
                                  Id
                                </Typography>
                              )}
                              <Typography
                                variant="overline"
                                style={{ wordBreak: "break-word" }}
                              >
                                {i?.quote_BookingId ?? "N/A"}
                              </Typography>
                            </Stack>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              maxHeight: "2.3rem",
                              alignItems: "center",
                            }}
                          >
                            {i?.isBooked && !i?.isBookingConfirmed ? (
                              <p
                                // className="blink_me"
                                style={{
                                  color: "#4290f5",
                                  fontWeight: "700",
                                }}
                              >
                                Booked
                              </p>
                            ) : i?.isHazardous &&
                              !i?.isBooked &&
                              !i?.isBookingConfirmed ? (
                              <p
                                // className="blink_me"
                                style={{
                                  color: "red",
                                  fontWeight: "700",
                                }}
                              >
                                Hazardous
                              </p>
                            ) : i?.isBooked &&
                              i?.isBookingConfirmed &&
                              !i?.isHazardous ? (
                              <p
                                // className="blink_me"
                                style={{
                                  color: "#13eb0c",
                                  fontWeight: "700",
                                }}
                              >
                                Confirmed
                              </p>
                            ) : !i?.isBooked &&
                              !i?.isBookingConfirmed &&
                              !i?.isHazardous ? (
                              <p
                                // className="blink_me"
                                style={{
                                  color: "#f59c02",
                                  fontWeight: "700",
                                }}
                              >
                                Unbooked Quote
                              </p>
                            ) : null}
                          </Grid>
                          <Grid item xs={12} sm={4} md={3}>
                            <Typography
                              variant="button"
                              // style={{ color: "#827e7e" }}
                            >
                              Origin
                            </Typography>
                            <Typography style={{ wordBreak: "break-word" }}>
                              {i?.freightOrigin ?? "N/A"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4} md={3}>
                            {i?.isHazardous ? null : (
                              <>
                                <Typography
                                  variant="button"
                                  // style={{ color: "#827e7e" }}
                                >
                                  Route
                                </Typography>
                                <Typography style={{ wordBreak: "break-word" }}>
                                  Via {i?.freightDestination ?? "N/A"}(
                                  {i?.freightDestinationCode ?? "N/A"})
                                </Typography>
                              </>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={4} md={3}>
                            <Typography
                              variant="button"
                              // style={{ color: "#827e7e" }}
                            >
                              Destination
                            </Typography>
                            <Typography style={{ wordBreak: "break-word" }}>
                              {i?.ipiDestination ?? "N/A"} (
                              {i?.ipiDestinationCode ?? "N/A"})
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4} md={3}>
                            {i?.isHazardous ? null : (
                              <>
                                <Typography
                                  variant="button"
                                  style={{ color: "#827e7e" }}
                                >
                                  Total Amount
                                </Typography>
                                <Typography style={{ wordBreak: "break-word" }}>
                                  {i?.totalQuotedAmount
                                    ? `${i?.totalQuotedAmount} USD`
                                    : "N/A"}
                                </Typography>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  );
                })}
              </>
            ) : 
            (
              <Grid
                item
                xs={12}
                className="d-flex justify-content-center align-items-center"
              >
                <Typography>No data found!</Typography>
              </Grid>
            )
          }{" "}
          </Grid> */
}
